import React from 'react';
import PropTypes from 'prop-types';

class DynamicImportComponent extends React.Component {
  state = { component: null };

  componentDidMount() {
    this.props.load()
      .then((component) => {
        this.setState(() => ({
          component: component.default ? component.default : component,
        }));
      });
  }

  render() {
    return this.props.children(this.state.component);
  }
}

DynamicImportComponent.propTypes = {
  children: PropTypes.func.isRequired,
  load: PropTypes.func.isRequired,
};

export default DynamicImportComponent;



// WEBPACK FOOTER //
// ./src/components/ui/DynamicImportComponent.js